import { render, staticRenderFns } from "./PmiMenu.vue?vue&type=template&id=81cb565a&scoped=true"
import script from "./PmiMenu.vue?vue&type=script&lang=js"
export * from "./PmiMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cb565a",
  null
  
)

export default component.exports